var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"fill-height"},[_c('overview'),_c('about-me'),_c('work-experience'),_c('sample-projects'),_c('all-projects'),_c('get-in-touch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }